export enum StaffAppRoutesEnum {
  Intro = '/seasonal-app/intro',
  Login = '/seasonal-app/login',
  AutoLogin= '/seasonal-app/auto-login',
  ChangePassword = '/seasonal-app/change-password',
  CreateAccount = '/seasonal-app/create-account',
  ContactInfo = '/seasonal-app/contact-info',
  Positions = '/seasonal-app/positions',
  LocationFinder = '/seasonal-app/location-finder',
  LocationPreferences = '/seasonal-app/location-preferences',
  EligibilityAndAvailability = '/seasonal-app/eligibility-and-availability',
  Experience = '/seasonal-app/experience',
  Education = '/seasonal-app/education',
  Portfolio = '/seasonal-app/portfolio',
  Submit = '/seasonal-app/submit',
  Confirmation = '/seasonal-app/confirmation'
}
